import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PrequalificationState {
  isNeedToUpdateBorrowerInLos: boolean;
  isNeedToUpdateBorrowerEmailInLos: boolean;
  isNeedToClearLoanInformation: boolean;
  isContractorNameInputDisabled: boolean;
  isContractorInfoCheckboxChecked: boolean;
  isBorrowerAuthorized: boolean;
  isPrequalStepPreset: boolean;
}

const initialState: PrequalificationState = {
  isNeedToUpdateBorrowerInLos: false,
  isNeedToUpdateBorrowerEmailInLos: false,
  isNeedToClearLoanInformation: false,
  isContractorNameInputDisabled: false,
  isContractorInfoCheckboxChecked: false,
  isBorrowerAuthorized: false,
  isPrequalStepPreset: false,
};

const prequalificationPortal = createSlice({
  name: 'prequalificationPortal',
  initialState: initialState,
  reducers: {
    setPrequalificationPortal: (state, { payload }: PayloadAction<Partial<PrequalificationState>>) => {
      Object.assign(state, payload);
    },
    clearPrequalificationPortal: () => initialState,
  },
});

export const { setPrequalificationPortal, clearPrequalificationPortal } = prequalificationPortal.actions;
export default prequalificationPortal.reducer;
